import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { setAuth } from '../Redux/authSlice';
import { Link } from 'react-router-dom';
import { FaPlus, FaSearch, FaUserGraduate, FaEye, FaPhoneAlt, FaCalendarAlt } from 'react-icons/fa';

const StudentCount: React.FC = () => {
  const [students, setStudents] = useState<any[]>([]);

  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [searchQuery, setSearchQuery] = useState<string>('');
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async (page: number, query?: string) => {
      try {
        const token = getCookie('token');
        if (!token) {
          dispatch(setAuth(false));
          setError('No token found. Please log in.');
          return;
        }
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        await axios.get('/users/user');
        dispatch(setAuth(true));

        const classesResponse = await axios.get('/Branches/classes/');


        let apiUrl = `/Branches/students/?page=${page}`;
        if (query) {
          apiUrl += `&name=${encodeURIComponent(query)}`;
        }

        const studentsResponse = await axios.get(apiUrl);
        const studentsData = studentsResponse.data.results.map((student: any) => ({
          ...student,
          class_name: getClassById(student.class_associated, classesResponse.data),
        }));
        setStudents(studentsData);

        const totalItems = studentsResponse.data.count;
        const pageSize = studentsResponse.data.page_size || 15;
        const calculatedTotalPages = Math.ceil(totalItems / pageSize);
        setTotalPages(isNaN(calculatedTotalPages) ? 1 : calculatedTotalPages);
      } catch (err) {
        console.error('Error fetching data:', err);
        dispatch(setAuth(false));
        dispatch(setAuth(false));
        setError('Failed to fetch data');
      } finally {
        setLoading(false);
      }
    };

    fetchData(currentPage, searchQuery);
  }, [currentPage, searchQuery, dispatch]);

  const getCookie = (name: string) => {
    const cookieName = name + "=";
    const decodedCookie = decodeURIComponent(document.cookie);
    const cookieArray = decodedCookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
      let cookie = cookieArray[i].trim();
      if (cookie.indexOf(cookieName) === 0) {
        return cookie.substring(cookieName.length, cookie.length);
      }
    }
    return '';
  };

  const getClassById = (classId: number, classes: any[]) => {
    const foundClass = classes.find(cls => cls.id === classId);
    return foundClass ? foundClass.name : 'Unknown';
  };

  const handlePageChange = (newPage: number) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setLoading(true);
      setCurrentPage(newPage);
    }
  };

  return (
    <div className="dashboard-content">
      {/* Header */}
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mb-5">
        <div>
          <h2 className="fw-bold text-dark mb-1">Maamulka Ardayda</h2>
          <p className="text-muted mb-0">Maamul ardaydaada, arag faahfaahinta iyo ku dar diiwaangelin cusub.</p>
        </div>
        <Link to="/add-students" className="btn btn-primary px-4 py-2 rounded-pill shadow-sm d-flex align-items-center fw-medium mt-3 mt-md-0">
          <FaPlus className="me-2" /> Ku Dar Arday Cusub
        </Link>
      </div>

      <div className="card-modern p-4 mb-4">
        {/* Search & Actions Bar */}
        <div className="row mb-4 align-items-center">
          <div className="col-md-6">
            <div className="input-group shadow-sm rounded-pill overflow-hidden bg-light border">
              <span className="input-group-text bg-transparent border-0 ps-3">
                <FaSearch className="text-muted" />
              </span>
              <input
                type="text"
                placeholder="Ku raadi magaca ardayga..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="form-control border-0 bg-transparent shadow-none"
                style={{ fontSize: '0.95rem' }}
              />
            </div>
          </div>
          <div className="col-md-6 text-md-end mt-3 mt-md-0">
            {/* Placeholder for future filters/exports */}
            <span className="text-muted small">Muujinaya {students.length} arday</span>
          </div>
        </div>

        {/* Table */}
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status"></div>
          </div>
        ) : error ? (
          <div className="alert alert-danger">{error}</div>
        ) : (
          <div className="table-responsive">
            <table className="table table-hover align-middle mb-0">
              <thead className="bg-light text-secondary">
                <tr style={{ fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                  <th className="py-3 ps-4 border-0">Magaca</th>
                  <th className="py-3 border-0">Fasalka</th>
                  <th className="py-3 border-0">Qeybta</th>
                  <th className="py-3 border-0">Taariikhda Diiwaangelinta</th>
                  <th className="py-3 border-0">Xiriirka Masuulka</th>
                  <th className="py-3 border-0">Degmada</th>
                  <th className="py-3 border-0">Jinsiga</th>
                  <th className="py-3 pe-4 text-center border-0">Falalka</th>
                </tr>
              </thead>
              <tbody className="border-top-0">
                {students.map((student) => (
                  <tr key={student.id} style={{ transition: 'background-color 0.2s' }}>
                    <td className="ps-4 py-3 fw-medium text-dark">
                      <div className="d-flex align-items-center">
                        <div className="bg-blue-50 text-blue-600 rounded-circle d-flex align-items-center justify-content-center me-3"
                          style={{ width: '36px', height: '36px' }}>
                          <FaUserGraduate size={14} />
                        </div>
                        <div>
                          <h6 className="mb-0 fw-semibold text-gray-900">{student.name}</h6>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span className="badge bg-blue-100 text-black px-3 py-1 rounded-pill">
                        {student.class_name}
                      </span>
                    </td>
                    <td className="text-gray-700">{student.section_name || '-'}</td>
                    <td>
                      <div className="d-flex align-items-center text-gray-700">
                        <FaCalendarAlt className="text-black me-2" size={14} />
                        {student.date_reg}
                      </div>
                    </td>
                    <td>
                      {student.guardian_number ? (
                        <a href={`tel:${student.guardian_number}`} className="text-decoration-none d-flex align-items-center text-gray-700">
                          <FaPhoneAlt className="text-black me-2" size={14} />
                          {student.guardian_number}
                        </a>
                      ) : '-'}
                    </td>
                    <td>
                      <div className="d-flex align-items-center">
                        <span className="badge bg-purple-100 text-black px-3 py-1 rounded-pill">
                          {student.district || '-'}
                        </span>
                      </div>
                    </td>

                    <td>
                      <div className="d-flex align-items-center">
                        <span className={`badge ${student.gender} text-black px-3 py-1 rounded-pill`}>
                          {student.gender || '-'}
                        </span>
                      </div>
                    </td>

                    <td className="text-center pe-4">
                      <Link
                        to={`/student-details/${student.id}`}
                        className="btn btn-sm btn-outline-primary px-3 d-flex align-items-center justify-content-center"
                        style={{ height: '32px' }}
                      >
                        <FaEye className="me-1" size={12} /> Arag
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>

            </table>
          </div>
        )}

        {/* Pagination */}
        <nav className="mt-4">
          <ul className="pagination justify-content-center">
            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
              <button className="page-link" onClick={() => handlePageChange(currentPage - 1)}>Hore</button>
            </li>
            {Array.from({ length: totalPages }, (_, index) => (
              <li key={index + 1} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                <button className="page-link" onClick={() => handlePageChange(index + 1)}>
                  {index + 1}
                </button>
              </li>
            ))}
            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
              <button className="page-link" onClick={() => handlePageChange(currentPage + 1)}>Xiga</button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

export default StudentCount;
